import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined, QuestionCircleFilled } from '@ant-design/icons'
import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import BundlesListView from '@components/shared/bundles/BundlesListView'
import BundleConceptModal from '@components/shared/bundles/BundleConceptModal'
import Can from '@shared/permissions/Can'
import ListPageHeader from '@shared/ListPageHeader'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { bundleService } from '@services/admin/bundleService'

const BundlesList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useAdminNotification() as { addJob: (jobId: string, jobName: string) => void }
  const [importModalVisible, setImportModalVisible] = useState(false)
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.bundles']}
        guideButton={
          <Tooltip title={t('concepts.bundles.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <>
            <Can requiredPermission="products:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="products:write">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => navigate('/bundles/new')}
              >
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <BundlesListView
        role="admin"
        service={bundleService}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
      <BundleConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}

export default BundlesList;
